"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseError = void 0;
const logger_1 = require("@linq/logger");
class ResponseError extends Error {
    constructor(options) {
        super();
        if (options) {
            this.message = options.message || '';
            this.remediation = options.remediation;
            this.userInputError = options.userInputError;
            this.errors = options.errors;
            this.attributes = options.attributes;
        }
        this.type = 'ResponseError';
        this.occurredAt = new Date().toISOString();
        if (options?.internalError) {
            logger_1.Logger.error(this.name, options.internalError.message, options.internalError);
        }
    }
}
exports.ResponseError = ResponseError;
//# sourceMappingURL=ResponseError.js.map